export function formatTableResultCount(
  filteredCount: number,
  totalCount: number | null,
  hasActiveFilters: boolean,
): string {
  const resultLabel = filteredCount === 1 ? "result" : "results";

  if (!hasActiveFilters) {
    return `${filteredCount} ${resultLabel}`;
  }

  if (totalCount === null) {
    return `Showing ${filteredCount} ${resultLabel}`;
  }

  return `Showing ${filteredCount} of ${totalCount} ${resultLabel}`;
}
